export default __webpack_public_path__ + "9ae918962d8969e9a478af600c3a6984.svg";